import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Checkbox } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECRadioGroupField } from '@/components/Forms/ECRadioGroupField';
import { ClosureType, RegFormType } from '@/api';
import { useForm } from 'react-hook-form';
import * as _ from 'underscore';
import { ECDateTimeField } from '@/components/Forms/ECDateTimeField';
import CardBlock from '@/components/CardBlock/CardBlock';

const PREFIX = 'RegFormClose';

const classes = {
  groupLabel: `${PREFIX}-groupLabel`,
};

const StyledCardBlock = styled(CardBlock)(({ theme }) => ({
  [`& .${classes.groupLabel}`]: {
    paddingTop: 12, //theme.spacing(1)
  },
}));

const RegFormClose = props => {
  const { className, regForm, save, ...rest } = props;

  const form = useForm();

  const handleSave = data => {
    save(data, form);
  };

  const closeType = form.watch('closureType');
  return (
    <StyledCardBlock title={'Закрытие регистрации'} form={form} save={handleSave}>
      <Grid container spacing={0} sx={{ margin: '-4px' }}>
        <Grid className={classes.groupLabel} size={4}>
          <Typography>Закрытие регистрации:</Typography>
        </Grid>
        <Grid size={8}>
          <ECRadioGroupField
            name={'closureType'}
            form={form}
            initial={regForm}
            defaultValue={ClosureType.Eternal}
            options={[
              { id: ClosureType.ByTime, name: 'По времени' },
              { id: ClosureType.ByLimit, name: 'По участникам' },
            ]}
            row
          />
          {closeType === ClosureType.ByTime && (
            <ECDateTimeField label={'Время закрытия'} name={'closeByTime'} initial={regForm} form={form} />
          )}
          {closeType === ClosureType.ByLimit && (
            <ECTextField label={'Лимит участников'} name={'closeByLimit'} initial={regForm} form={form} />
          )}
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Сообщение при закрытой регистрации:</Typography>
        </Grid>
        <Grid size={8}>
          <ECTextField label='' name='closedText' initial={regForm} form={form} multiline rows={4} />
        </Grid>
      </Grid>
    </StyledCardBlock>
  );
};

export default RegFormClose;
